import { MAX_PRODUCTS_DISPLAY } from './constants';
import {
    ContinueShoppingDataType,
    ContinueShoppingCardItem,
    TrackingItemType,
    PreparedDataType,
} from './types';

export const mapCardItemToTrackingItem = (article: ContinueShoppingCardItem): TrackingItemType => {
    return {
        sku: String(article.sku),
        brandCode: String(article.brand),
        campaignIdentifier: String(article.campaignIdentifier),
        price: Number(article.price),
        specialPrice: article.specialPrice != null ? Number(article.specialPrice) : null,
        stockStatus: article.stockStatus,
        plusEarlyAccess: Boolean(article.plusEarlyAccess),
        sustainable: Boolean(article.sustainable),
        categoryId: null,
        simples: [],
    };
};

export const prepareContinueShoppingData = (data: ContinueShoppingDataType): PreparedDataType => {
    const panelData = data.map(category => {
        const shouldShowSeeAll = category.hasMore;
        const categoriesList = category.configs.slice(0, MAX_PRODUCTS_DISPLAY);

        return {
            category,
            shouldShowSeeAll,
            categoriesList,
        };
    });

    // Build tracking items from displayed items only (sliced categoriesList)
    const displayedItems = panelData.flatMap(panel => panel.categoriesList);
    const trackingItems: TrackingItemType[] = displayedItems.map(mapCardItemToTrackingItem);

    return {
        panelData,
        trackingItems,
    };
};
